var map = {
	"./home1.gif": 9934,
	"./home2.jpg": 7630,
	"./home3.jpg": 5675,
	"./home4.gif": 2891,
	"./home5.gif": 3586,
	"./home6.jpg": 1178,
	"./home7.gif": 9748
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8504;